// import BrowserPrint, { Device } from "zebra-print";
import qz from "qz-tray";

import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";
import { zebraPrintModel } from "../ZebraPrintModel";

const DEFAULT_PRINTER = "ZDesigner ZT231-203dpi ZPL";

export const connect = async (): Promise<void> => {
  try {
    await qz.websocket.connect();
    console.log("QZ Tray connected");

    const printers: string | string[] = await qz.printers.find();
    if (Array.isArray(printers)) {
      for (const printer of printers) {
        if (printer === DEFAULT_PRINTER) {
          zebraPrintModel.device = printer;
          zebraPrintModel.setState("connected");
          console.log("Zebra printer connected", printer);
          break;
        }
      }
    } else {
      if (printers === DEFAULT_PRINTER) {
        zebraPrintModel.device = printers;
        zebraPrintModel.setState("connected");
        console.log("Zebra printer connected", printers);
      }
    }

    /*
    BrowserPrint.getDefaultDevice(
      "printer",
      function (device: Device) {
        zebraPrintModel.device = device;
        zebraPrintModel.setState("connected");
        console.log("Zebra printer connected", device);
      },
      function (error: unknown) {
        console.log(error);
      }
    );
    */

  } catch (error: unknown) {
    appFaultModel.catchAppError("ZebraPrintModel.connect", {}, error);
  }
};
